import type { LoginResponse, AuthUser, MemberRole } from '@eriko/shared-types';
import type { LoginInput, RegisterInput, OnboardingInput } from '@eriko/validation';
import { apiClient, publicClient } from '../lib/api';
import { ENDPOINTS } from './endpoints';

export interface AuthMeResponse {
  user: AuthUser;
  organization: { id: string; name: string; slug: string; logoUrl: string | null };
  role: MemberRole;
  isOnboarded: boolean;
}

export async function getAuthMe(): Promise<AuthMeResponse> {
  const res = await apiClient.get<AuthMeResponse>(ENDPOINTS.auth.me);
  return res.data;
}

export async function login(input: LoginInput): Promise<LoginResponse> {
  const res = await publicClient.post<LoginResponse>(ENDPOINTS.auth.login, input);
  return res.data;
}

export async function register(input: RegisterInput): Promise<LoginResponse> {
  const res = await publicClient.post<LoginResponse>(ENDPOINTS.auth.register, input);
  return res.data;
}

export async function logout(refreshToken: string): Promise<{ message: string }> {
  const res = await publicClient.post<{ message: string }>(ENDPOINTS.auth.logout, { refreshToken });
  return res.data;
}

export async function forgotPassword(email: string): Promise<{ message: string }> {
  const res = await publicClient.post<{ message: string }>(ENDPOINTS.auth.forgotPassword, { email });
  return res.data;
}

export async function resetPassword(input: { token: string; password: string }): Promise<{ message: string }> {
  const res = await publicClient.post<{ message: string }>(ENDPOINTS.auth.resetPassword, input);
  return res.data;
}

export async function verifyEmail(token: string): Promise<{ message: string }> {
  const res = await publicClient.get<{ message: string }>(ENDPOINTS.auth.verifyEmail(token));
  return res.data;
}

export async function resendVerify(): Promise<{ message: string }> {
  const res = await apiClient.post<{ message: string }>(ENDPOINTS.auth.resendVerify);
  return res.data;
}

export async function updateOnboarding(input: OnboardingInput): Promise<{ message: string }> {
  const res = await apiClient.post<{ message: string }>(ENDPOINTS.auth.onboarding, input);
  return res.data;
}
